<template>
  <div class="cangchu_ck">
    <div v-if="!digshow" class="t_out_box">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form ref="search" style="display: flex" :model="searchForm" label-position="center" label-width="90px">
            <el-form-item label="化学品名称:">
              <el-input v-model="searchForm.chemicalName" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="申请日期:">
              <el-row>
                <el-col :span="10">
                  <el-date-picker v-model="searchForm.beginTime" type="date" style="width: 100%" placeholder="选择日期" />
                </el-col>
                <el-col style="text-align: center" class="line" :span="3">-</el-col>
                <el-col :span="10">
                  <el-date-picker v-model="searchForm.endTime" type="date" style="width: 100%" placeholder="选择日期" />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="申请批号:">
              <el-input v-model="searchForm.applyNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="追溯码状态:">
              <el-select v-model="searchForm.traceStatus" placeholder="请选择">
                <el-option label="审批中" value="11"></el-option>
                <el-option label="已拒绝" value="13"></el-option>
                <el-option label="待发放" value="12"></el-option>
                <el-option label="已发放" value="21"></el-option>
              </el-select>
            </el-form-item>
            <el-button class="sousuoButton" icon="el-icon-search" round size="small" type="primary"
              @click="handleCurrentChange(1)">搜索</el-button>
            <el-button class="resetbutton" icon="el-icon-refresh-right" @click="reset">重置</el-button>
          </el-form>
        </div>
      </div>
      <div style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 51px;
        ">
        <div class="tablemes">
          <el-table ref="cktable" v-loading="loading" :data="tableData" border :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }" style="width: 100%" :cell-style="cellStyle"
            :header-cell-class-name="cellClass" @selection-change="handleSelectionChange">
            <el-table-column>
              <template slot="header">
                <el-button v-preventReClick type="primary" class="addButton" size="mini" style="border: none"
                  icon="el-icon-plus" @click="add">新增</el-button>
                <el-button v-preventReClick icon="el-icon-plus" class="addmessedit" size="mini"
                  @click="addEditMes">复制新增</el-button>
              </template>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="applyNo" label="申请批号" width="180"></el-table-column>
              <el-table-column prop="chemicalName" label="化学品名称"></el-table-column>
              <el-table-column prop="applyTime" label="申请时间" width="180"></el-table-column>
              <el-table-column prop="traceStatus" label="追溯码状态" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.traceStatusLabel || scope.row.traceStatus }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleDetail(scope.row)">详情</el-button>
<!--                  <el-button v-if="scope.row.traceStatus === '13'" size="mini"-->
<!--                    @click="handleCopy(scope.row)">复制</el-button>-->
                  <el-button v-if="scope.row.traceStatus === '21'" size="mini"
                    @click="handleDownload(scope.row)">下载追溯码</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination background layout="prev, pager,next,jumper,total,sizes" :page-sizes="[10, 20, 30, 40]"
            :total="pagination.total" :page-size="pagination.pageSize" class="el-page" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="pagination.currentPage" />
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <!-- 详情和新增组件 -->
    <ZsmglDetail :digshow="digshow" :isDetails="isDetails" :row="row" :dataobj="dataobj" :addForm="addForm"
      :hxpList="hxpList" :bzList="bzList" :RFIDList="RFIDList" @back="back" @addHxp="addHxp" @onSubmit="onSubmit" />
  </div>
</template>

<script>
import {
  getZsmglList,
  addZsmgl,
  getDwxx,
  getZsmglDetail,
  exportAllBySqid,
  getBqcsInfo
} from '@/assets/js/zsmgl'
import ZsmglDetail from './zsmglDetail'
// 获取接口地址
import {
  gethxpJl,
} from '@/assets/js/common.js'
export default {
  name: 'zsmglMain',
  components: {
    ZsmglDetail
  },
  data() {
    return {
      digshow: false,
      isDetails: false,
      addForm: {
        hxpList: []
      },
      loading: false,
      searchForm: {
        chemicalType: '',
        chemicalName: '',
        beginTime: '',
        endTime: '',
        applyNo: '',
        traceStatus: ''
      },
      tableData: [], // 初始化为空数组，通过API获取数据
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      row: {},
      RFIDList: [],
      hxpList: [],
      addInfo: {},
      bzList: [{ label: '上层包装', value: '0' }, { label: '最小包装', value: '1' }],
      dataobj: [],
      rows: []
    }
  },
  created() {
    // 组件初始化时获取数据
    this.handleCurrentChange(1)
    this.initData();

  },
  methods: {
    addEditMes() {
      if (this.rows.length === 0) {
        this.$message.warning('请先选择一条记录进行复制新增');
        return;
      }
      this.handleDetail(this.rows[0], 'add');
    },
    findHxpNode(options, value) {
      for (const node of options) {
        if (node.value === value) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findHxpNode(node.children, value);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },
    onSubmit() {
      // 基本信息校验
      if (!this.addForm.lxrXm) {
        this.$message.warn('请输入单位联系人');
        return;
      }
      if (!this.addForm.lxrSjh) {
        this.$message.warn('请输入联系人手机号码');
        return;
      }

      // 化学品列表校验
      if (this.addForm.hxpList.length === 0) {
        this.$message.warning('请添加至少一条化学品信息');
        return;
      }

      let errorRows = [];
      for (let i = 0; i < this.addForm.hxpList.length; i++) {
        const item = this.addForm.hxpList[i];
        const errors = [];

        if (!item.hxpBmList || item.hxpBmList.length === 0) {
          errors.push('化学品名称');
        }
        if (!item.bzcjBm) {
          errors.push('包装层级');
        }
        if (!item.bqcsBm) {
          errors.push('RFID厂家');
        }
        if (!item.sqsl || item.sqsl <= 0) {
          errors.push('申请数量');
        }

        if (errors.length > 0) {
          errorRows.push(`第${i + 1}行：${errors.join('、')}`);
        }
      }

      if (errorRows.length > 0) {
        this.$message.warning(`请完善以下信息：\n${errorRows.join('\n')}`);
        return;
      }

      // 校验通过，继续提交逻辑

      // 添加包装层级和RFID厂家名称
      this.addForm.hxpList.forEach(item => {
        // 查找包装层级名称
        const bzItem = this.bzList.find(bz => bz.value == item.bzcjBm);
        if (bzItem) {
          item.bzcjMc = bzItem.label;
        }

        // 查找RFID厂家名称
        const rfidItem = this.RFIDList.find(rfid => rfid.bm == item.bqcsBm);
        if (rfidItem) {
          item.bqcsMc = rfidItem.mc;
        }

        // 处理化学品代码和名称
        if (item.hxpBmList && item.hxpBmList.length > 0) {
          // 获取最后一级的值作为hxpBm
          item.hxpBm = item.hxpBmList[item.hxpBmList.length - 1];
          // 查找对应的节点获取label作为hxpMc
          const hxpNode = this.findHxpNode(this.hxpList, item.hxpBm);
          if (hxpNode) {
            item.hxpMc = hxpNode.label;
          }
        }
      });

      console.log('提交数据:', this.addForm);
      // 调用API提交数据
      addZsmgl(this.addForm).then(res => {
        if (res.data.code === '000000') {
          this.$message.success('提交成功');
          // 重置表单或关闭对话框
          this.digshow = false;
          // 刷新列表
          this.handleCurrentChange(1);
        }
      }).catch(err => {
        console.error('提交失败:', err);
        this.$message.error('提交失败');
      });
    },
    addHxp() {
      if (this.addForm.hxpList.length >= 10) {
        this.$message.warning('最多只能添加10条追溯码信息');
        return;
      }
      this.addForm.hxpList.push({})
    },
    initData() {
      getDwxx().then(res => {
        if (res.data.code === '000000') {
          this.addInfo = res.data.data
        }
      }).catch(err => {
        console.error('获取单位信息失败:', err)
      })
      getBqcsInfo().then(res => {
        if (res.data.code === '000000') {
          this.RFIDList = res.data.data
        }
      }).catch(err => {
        console.error('获取化学品分类列表失败:', err)
      })
      // 获取化学品级联数据
      gethxpJl().then((e) => {
        this.hxpList = e.data.data
      })
    },
    add() {
      this.isDetails = false;
      this.digshow = !this.digshow
      this.addForm = {
        ...this.addInfo,
        hxpList: [{}]
      }
    },
    back() {
      this.digshow = !this.digshow
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 4) {
        switch (row.traceStatus) {
          case '11': // 审批中
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '13': // 已驳回
            cellStyle = 'color:#F56C6C;font-weight:bold '
            break
          case '20': // 待发放
            cellStyle = 'color:#E6A23C;font-weight:bold '
            break
          case '21': // 已发放
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    handleCurrentChange(val) {
      // 查询逻辑
      this.loading = true
      this.pagination.currentPage = val

      // 构建查询参数
      const params = {
        page: val,
        size: this.pagination.pageSize,
        param: {
          hxpMc: this.searchForm.chemicalName,
          beginTime: this.searchForm.beginTime,
          endTime: this.searchForm.endTime,
          sqph: this.searchForm.applyNo,
          zt: this.searchForm.traceStatus
        }
      }

      // 调用API获取数据
      getZsmglList(params).then(res => {
        if (res.data.code === '000000') {
          // 调整数据结构以匹配组件需求
          this.tableData = res.data.data.rows.map(item => ({
            id: item.id,
            applyNo: item.sqph,
            chemicalName: item.hxpMc,
            applyTime: item.sqsj,
            traceStatus: item.zt,
            traceStatusLabel: item.ztLabel
          }))
          this.pagination.total = res.data.data.total
        }
      }).catch(err => {
        console.error('获取追溯码列表失败:', err)
      }).finally(() => {
        this.loading = false
      })
    },
    reset() {
      // 重置表单
      this.searchForm = {
        chemicalType: '',
        chemicalName: '',
        beginTime: '',
        endTime: '',
        applyNo: '',
        traceStatus: ''
      }
      this.handleCurrentChange(1)
    },
    handleAdd() {
      // 新增逻辑
      console.log('新增')
      // 这里应该跳转到新增页面或打开新增对话框
      // 例如: this.$router.push('/zsmgl/add')
    },
    handleDetail(row, type = 'detail') {
      // 调用API获取详情
      getZsmglDetail(row.id).then(res => {
        if (res.data.code === '000000') {
          // 这里应该跳转到详情页面或打开详情对话框
          console.log('详情数据:', res.data.data)
          this.digshow = true;
          if (type === 'detail') {
            this.isDetails = true;
            this.row = res.data.data;
            this.dataobj = res.data.data.sphjDtoList;
            if (this.dataobj) {
              this.dataobj.forEach((hj, index) => {
                if (index == this.dataobj.length - 1 || this.dataobj.length == 1) {
                  hj.icon = 'el-icon-success'
                  hj.type = 'success'
                  hj.size = 'large'
                }
              })
            }
            if (this.dataobj) {
              this.dataobj.forEach((item) => {
                if (item.sftyLabel == '待审批') {
                  item.color = 'Orange'
                } else if (item.sftyLabel == '同意') {
                  item.color = '#00ceb7'
                } else if (item.sftyLabel == '不同意') {
                  item.color = 'red'
                }
              })
            }
          } else {
            this.isDetails = false;
            this.addForm = {
              dwmc: res.data.data.dwmc,
              shtyxydm: res.data.data.shtyxydm,
              lxrXm: res.data.data.lxrXm,
              lxrSjh: res.data.data.lxrSjh,
              hxpList: res.data.data.hxpList.map(item => ({
                hxpBmList: item.hxpBm ? this.findPathInTree(this.hxpList, item.hxpBm) : [],
                bzcjBm: item.bzcjBm,
                bqcsBm: item.bqcsBm,
                sqsl: item.sqsl
              }))
            }
          }

        }
      }).catch(err => {
        console.error('获取追溯码详情失败:', err)
      })
    },
    handleCopy(row) {
      // 复制逻辑
      console.log('复制:', row)
      // 这里应该实现复制功能
      // 例如: 获取详情后，使用addZsmgl接口创建新的记录
      getZsmglDetail(row.id).then(res => {
        if (res.data.code === '000000') {
          const detailData = res.data.data
          // 构建复制数据
          const copyData = {
            lxrXm: detailData.lxrXm,
            lxrSjh: detailData.lxrSjh,
            hxpList: detailData.hxpList.map(item => ({
              hxpBm: item.hxpBm,
              hxpMc: item.hxpMc,
              bzcjBm: item.bzcjBm,
              bzcjMc: item.bzcjMc,
              bqcsBm: item.bqcsBm,
              bqcsMc: item.bqcsMc,
              sqsl: item.sqsl
            }))
          }
          // 调用新增接口
          addZsmgl(copyData).then(res => {
            if (res.data.code === '000000') {
              this.$message.success('复制成功')
              this.handleCurrentChange(1)
            }
          }).catch(err => {
            console.error('复制追溯码失败:', err)
            this.$message.error('复制失败')
          })
        }
      }).catch(err => {
        console.error('获取追溯码详情失败:', err)
      })
    },
    handleDownload(row) {
      // 下载编码文件逻辑
      // 调用API下载文件
      exportAllBySqid(row.id).then(res => {
        // 处理下载文件
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `追溯码_${row.applyNo}.xlsx`
        a.click()
        URL.revokeObjectURL(url)
      }).catch(err => {
        console.error('下载编码文件失败:', err)
        this.$message.error('下载失败')
      })
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.handleCurrentChange(1)
    },
    handleSelectionChange(selection) {
      if (selection.length) {
        this.rows = [selection[selection.length - 1]];
      }
      if (selection.length > 1) {
        // 清除所有选择
        this.$refs.cktable.clearSelection()
        // 只选择最后一条
        this.$refs.cktable.toggleRowSelection(selection[selection.length - 1], true)
      }
    },
    findPathInTree(tree, targetValue) {
      let path = []

      function traverse(nodes, currentPath) {
        for (const node of nodes) {
          const nodeValue = Number(node.value)
          const currentTargetValue = Number(targetValue)

          if (nodeValue === currentTargetValue) {
            path = [...currentPath, node.value]
            return true
          }

          if (node.children && node.children.length > 0) {
            if (traverse(node.children, [...currentPath, node.value])) {
              return true
            }
          }
        }
        return false
      }

      traverse(tree, [])
      console.log(path, tree, targetValue, '2222');
      return path
    }
  }
}
</script>

<style scoped lang="less">
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}

.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;

  .bottom_title {
    .title {
      &::before {
        background: #D03CE9;
      }
    }
  }

  .title {
    position: relative;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;

    &::before {
      content: '';
      width: 4px;
      height: 18px;
      background-color: #4170ff;
      position: absolute;
      left: -20px;
      top: 5px;
    }
  }
}

.el-table--border {
  z-index: 0;
}

.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}

.cangchu_ck {
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;

    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;

      &:last-child {
        width: 90px;
        height: 39px;

        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }

  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }

    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }

  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;

    .el-pagination__total {
      margin-left: 8px;
    }

    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }

    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }

    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }

    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }

    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

// 取消全选 样式
/deep/ .disableheadselection>.cell .el-checkbox__inner {
  display: none !important;
}
</style>
